import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Tags' })({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        marginBottom: 24,
        '@media (max-width: 960px)': {
            marginBottom: 0
        }
    },
    line: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8
    },
    date: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        whiteSpace: 'nowrap'
    },
    time: {
        color: '#aaa'
    },
    tagIcon: {
        width: 16,
        height: 16
    }
});
